export const COMPANY = {
  name: "SSDE LTD",
  tagline: "Design That Defines Your Brand.",
  email: "company.ssdeltd@gmail.com",
  phone: "+44 7747 525106",
  phoneHref: "tel:+447747525106",
  address: "40 Roding Court, Ilford, IG1 2FH, United Kingdom",
};

export const IMAGES = {
  heroMain:
    "https://images.unsplash.com/photo-1716471330463-f475b00f0506?crop=entropy&cs=srgb&fm=jpg&q=85",
  heroSecondary:
    "https://images.unsplash.com/photo-1605699717632-0b9b657ff3b5?crop=entropy&cs=srgb&fm=jpg&q=85",
  aboutEditorial:
    "https://images.pexels.com/photos/3747264/pexels-photo-3747264.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  aboutStudio:
    "https://images.unsplash.com/photo-1643485839726-c9d4fac1c9bd?crop=entropy&cs=srgb&fm=jpg&q=85",
};

export const SERVICES = [
  {
    slug: "graphic-design",
    title: "Graphic Design",
    short: "Professional visual design for business communication, promotional materials and marketing content.",
    highlights: ["Marketing & promotional visuals", "Social and print-ready artwork", "Consistent brand styling"],
    image:
      "https://images.unsplash.com/photo-1579783900882-c0d3dad7b119?crop=entropy&cs=srgb&fm=jpg&q=85",
    alt: "Colourful exhibition posters and graphic prints on a gallery wall",
  },
  {
    slug: "logo-design",
    title: "Logo Design",
    short: "Distinctive logo concepts designed to represent a business's identity and provide a consistent visual foundation.",
    highlights: ["Original concept exploration", "Primary & secondary lockups", "Formats for print and digital"],
    image:
      "https://images.unsplash.com/photo-1561070791-2526d30994b5?crop=entropy&cs=srgb&fm=jpg&q=85",
    alt: "Logo design printed in colour on brand stationery cards",
  },
  {
    slug: "branding-visual-identity",
    title: "Branding & Visual Identity",
    short: "Coordinated visual identity solutions, including colour palettes, typography, logo applications and brand presentation.",
    highlights: ["Colour & typography systems", "Stationery and collateral", "Brand presentation guidelines"],
    image:
      "https://images.unsplash.com/photo-1773833335200-3925f4036158?crop=entropy&cs=srgb&fm=jpg&q=85",
    alt: "Colourful stationery suite with printed logo cards and envelopes",
  },
  {
    slug: "brochures-marketing",
    title: "Brochures & Marketing Materials",
    short: "Professionally designed brochures, flyers, business stationery, promotional materials and other marketing assets.",
    highlights: ["Brochures, flyers & leaflets", "Business stationery", "Editorial layouts"],
    image:
      "https://images.pexels.com/photos/3747264/pexels-photo-3747264.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Open magazine with colourful editorial spreads and poster designs",
  },
  {
    slug: "packaging-design",
    title: "Packaging Design",
    short: "Creative packaging concepts that communicate brand identity and present products professionally.",
    highlights: ["Structural & surface design", "Label and wrap artwork", "Retail-ready presentation"],
    image:
      "https://images.unsplash.com/photo-1617825295690-28ae56c56135?crop=entropy&cs=srgb&fm=jpg&q=85",
    alt: "Botanical packaging boxes with printed labels and pastel design",
  },
  {
    slug: "website-layout-design",
    title: "Website Layout Design",
    short: "Well-structured website layouts that balance visual appeal, usability and clear information hierarchy.",
    highlights: ["Page layout systems", "Responsive structure", "Clear content hierarchy"],
    image:
      "https://images.unsplash.com/photo-1581291518633-83b4ebd1d83e?crop=entropy&cs=srgb&fm=jpg&q=85",
    alt: "Laptop screen showing a colourful, well-structured website layout",
  },
  {
    slug: "ui-design",
    title: "User Interface Design",
    short: "Thoughtful interface design for digital products, websites and interactive experiences.",
    highlights: ["Interface components", "Design systems", "Prototype-ready screens"],
    image:
      "https://images.unsplash.com/photo-1551650975-87deedd944c3?crop=entropy&cs=srgb&fm=jpg&q=85",
    alt: "Smartphone displaying a colourful designed app interface",
  },
  {
    slug: "digital-content",
    title: "Digital Content Creation",
    short: "Visual assets for online communication, digital marketing and brand presentation.",
    highlights: ["Campaign visuals", "Social media assets", "Digital brand content"],
    image:
      "https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?crop=entropy&cs=srgb&fm=jpg&q=85",
    alt: "Vibrant 3D digital campaign artwork with colourful gradient forms",
  },
];

export const PORTFOLIO_CATEGORIES = [
  "All",
  "Branding & Identity",
  "Logo Design",
  "Graphic Design",
  "Brochures & Print",
  "Packaging Design",
  "Website Design",
  "UI Design",
  "Digital Assets",
];

export const PORTFOLIO = [
  {
    id: "p1",
    title: "Aura Botanicals",
    category: "Packaging Design",
    image:
      "https://images.unsplash.com/photo-1617825295690-28ae56c56135?crop=entropy&cs=srgb&fm=jpg&q=85",
    description: "Botanical cosmetic packaging concept with pastel tones, leaf cut-outs and printed product labels.",
    overview:
      "A packaging concept exploring how colour and craft can signal quality at a glance. The study pairs soft pastel cartons with botanical cut-out detailing and cleanly printed labels, giving the range a fresh, apothecary-inspired character.",
    approach:
      "The direction centred on quiet luxury with a colourful twist: a pastel colour family to distinguish each product, an embossed wordmark, and one muted-gold foil accent. Every surface was considered as part of a sequence — shelf presence, first touch, and the reveal of the product inside.",
    deliverables: ["Primary box artwork", "Label & wrap system", "Foil & emboss specification", "Shelf presentation mockups"],
  },
  {
    id: "p2",
    title: "Vanguard & Co.",
    category: "Branding & Identity",
    image:
      "https://images.unsplash.com/photo-1773833335200-3925f4036158?crop=entropy&cs=srgb&fm=jpg&q=85",
    description: "Stationery suite concept with printed logo cards, envelopes and colourful accent swatches.",
    overview:
      "An identity concept for a firm whose clients expect discretion and precision — but never dullness. The system pairs a confident serif wordmark with colourful accent cards and envelopes that bring warmth to an otherwise restrained suite.",
    approach:
      "The study focused on consistency at every touchpoint: letterheads, business cards, envelopes and document covers all follow one clear grid, with the accent colour doing the expressive work, so the brand reads identically whether it arrives by post or on screen.",
    deliverables: ["Wordmark & lockups", "Stationery suite", "Colour & typography system", "Document templates"],
  },
  {
    id: "p3",
    title: "Kensington Journal",
    category: "Brochures & Print",
    image:
      "https://images.pexels.com/photos/3747264/pexels-photo-3747264.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    description: "Quarterly editorial concept with colourful poster spreads and artistic studio layouts.",
    overview:
      "An editorial concept for a quarterly journal covering art and architecture. The layout system balances long-form reading with bold, colourful poster spreads, using a flexible twelve-column grid that adapts from dense essays to full-bleed artwork.",
    approach:
      "Typography leads the design: a display serif for headlines, a highly legible companion for body text, and a disciplined hierarchy of captions, pull quotes and folios that keeps long articles effortless to navigate — while colour gives each issue its own energy.",
    deliverables: ["Master page grid", "Cover & feature layouts", "Typography specification", "Print-ready artwork"],
  },
  {
    id: "p4",
    title: "Solis Studio",
    category: "Website Design",
    image:
      "https://images.unsplash.com/photo-1581291518633-83b4ebd1d83e?crop=entropy&cs=srgb&fm=jpg&q=85",
    description: "Website layout concept with a colourful, modern interface shown in a bright workspace.",
    overview:
      "A website layout concept for an architecture practice, designed to let large project photography and bold colour blocks breathe. Pages are structured around wide imagery, calm spacing and a navigation model that keeps the portfolio one click away.",
    approach:
      "The layout prioritises information hierarchy: project title, location and summary appear before anything decorative. Breakpoints were designed content-first, so the experience stays composed from a phone to a studio display.",
    deliverables: ["Homepage & project layouts", "Responsive breakpoint system", "Component library", "Handoff specifications"],
  },
  {
    id: "p5",
    title: "Lumina Health",
    category: "UI Design",
    image:
      "https://images.unsplash.com/photo-1551650975-87deedd944c3?crop=entropy&cs=srgb&fm=jpg&q=85",
    description: "Interface concept for a vibrant, intuitive wellness tracking application.",
    overview:
      "An interface concept for a wellness application where clarity matters more than novelty. The study explores how a vibrant but disciplined palette, generous touch targets and plain-language labels can make daily tracking feel effortless.",
    approach:
      "Components were designed as a system first — buttons, cards, charts and inputs — then assembled into key flows. Accessibility guided decisions throughout, from contrast ratios to focus states and readable type sizes.",
    deliverables: ["Component design system", "Core screen flows", "Interactive prototype", "Accessibility annotations"],
  },
  {
    id: "p6",
    title: "Maison Botanique",
    category: "Logo Design",
    image:
      "https://images.unsplash.com/photo-1561070791-2526d30994b5?crop=entropy&cs=srgb&fm=jpg&q=85",
    description: "Typographic logo concept printed in colour across floral brand stationery.",
    overview:
      "A logo concept for a boutique floristry brand. The study pairs a refined typographic wordmark with a compact monogram, printed in a rich colour palette across cards and packaging so the identity feels alive at every size.",
    approach:
      "Letterforms were drawn with botanical cues — subtle tapering and organic curves — while staying disciplined enough for small sizes. A palette of deep botanical tones with soft gold completes the identity foundation.",
    deliverables: ["Primary wordmark", "Monogram & sub-marks", "Colour palette", "Usage guidelines"],
  },
  {
    id: "p7",
    title: "Forma Series",
    category: "Graphic Design",
    image:
      "https://images.unsplash.com/photo-1579783900882-c0d3dad7b119?crop=entropy&cs=srgb&fm=jpg&q=85",
    description: "Exhibition graphics and bold, colourful Swiss-inspired poster collection.",
    overview:
      "A graphic design study in the Swiss tradition with a bolder palette: a series of exhibition posters built on strict grids, confident type and vivid colour fields. Each poster shares one system, yet each finds its own rhythm.",
    approach:
      "The exercise was one of discipline — every element earns its place. Variation comes from scale, rotation, spacing and colour rather than added decoration, demonstrating how a strong system produces range without noise.",
    deliverables: ["Poster series artwork", "Grid & type system", "Exhibition signage", "Print production files"],
  },
  {
    id: "p8",
    title: "Novus Campaign",
    category: "Digital Assets",
    image:
      "https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?crop=entropy&cs=srgb&fm=jpg&q=85",
    description: "Digital campaign concept with vibrant 3D artwork and social media asset suites.",
    overview:
      "A digital asset suite concept for a product launch, covering social, display and email formats. Vibrant 3D artwork and gradient forms give the campaign instant recognition, translated cleanly into every required size.",
    approach:
      "Assets were designed as families rather than one-offs: shared typography, colour and motion principles keep the campaign recognisable whether it appears as a story, a banner or a header image.",
    deliverables: ["Social media asset suite", "Display banner set", "Email header designs", "Motion-ready source files"],
  },
];

export const MARQUEE_ITEMS = [
  "Branding",
  "Visual Identity",
  "Logo Design",
  "Packaging",
  "Editorial & Print",
  "Website Layouts",
  "UI Design",
  "Digital Content",
];

export const PRINCIPLES = [
  {
    title: "Professional Presentation",
    text: "Every deliverable is prepared to a standard that presents your business with credibility and care.",
  },
  {
    title: "Creative & Considered",
    text: "Design decisions are deliberate — rooted in your goals, your audience and the character of your brand.",
  },
  {
    title: "Consistent Identity",
    text: "Colour, typography and imagery are coordinated so your brand reads clearly across every touchpoint.",
  },
  {
    title: "Attention to Detail",
    text: "From kerning to colour balance, the small details receive the same care as the big ideas.",
  },
  {
    title: "Tailored to You",
    text: "No templates or shortcuts — every solution is shaped around the specific requirements of your project.",
  },
];
